export const MAX_SERVICE_LINKS_TO_DISPLAY = 5;

export const EVENT_CONTACT_PREFIX = 'partner_contact_form: ';

export const EVENT_CONTACT_FOOTER = `${EVENT_CONTACT_PREFIX}clicked link in footer`;
export const EVENT_CONTACT_GENERIC = `${EVENT_CONTACT_PREFIX}clicked link in form`;
export const EVENT_CONTACT_LEVEL_UP = `${EVENT_CONTACT_PREFIX}clicked level up link`;
export const EVENT_CONTACT_LOG_IN = `${EVENT_CONTACT_PREFIX}clicked log in button`;
export const EVENT_CONTACT_SIGN_UP = `${EVENT_CONTACT_PREFIX}clicked sign up button`;
export const EVENT_CONTACT_QA_RESPONSE = `${EVENT_CONTACT_PREFIX}responded to quick answer`;
export const EVENT_CONTACT_QA_CONTINUE = `${EVENT_CONTACT_PREFIX}continued after helpful quick answer`;
export const EVENT_CONTACT_INIT = `${EVENT_CONTACT_PREFIX}opened form`;
export const EVENT_CONTACT_STEP = `${EVENT_CONTACT_PREFIX}changed node`;
export const EVENT_CONTACT_SENT = `${EVENT_CONTACT_PREFIX}sent form`;
export const EVENT_CONTACT_ERROR = `${EVENT_CONTACT_PREFIX}got error sending form`;
export const EVENT_CONTACT_DISCUSSION = `${EVENT_CONTACT_PREFIX}clicked community discussion`;

export const AVRO_EVENT_USER_INTERACTION =
  'schema:web_analytics.tracking.user_interaction.UserInteractionEvent';
